import { ThemeUICSSObject } from '@apia/theme';
import { addBoundary } from '@apia/util';
import { MutableRefObject } from 'react';
import { applyStylesToElement } from '../hooks/useStyleState';

export function handleMouseMove({
  ev,
  initialPosition,
  initialMousePosition,
  modalMainElement,
  setStyle,
}: {
  ev: MouseEvent;
  initialPosition: MutableRefObject<null | DOMRect>;
  initialMousePosition: MutableRefObject<null | { x: number; y: number }>;
  modalMainElement: HTMLElement;
  setStyle: (newState: React.SetStateAction<Partial<ThemeUICSSObject>>) => void;
}) {
  if (initialPosition.current) {
    ev.preventDefault();
    const diffX = ev.clientX - initialMousePosition.current!.x;
    const diffY = ev.clientY - initialMousePosition.current!.y;

    const newLeft = addBoundary(
      initialPosition.current.left + diffX,
      0,
      window.innerWidth - 50,
    );
    const newTop = addBoundary(
      initialPosition.current.top + diffY,
      0,
      window.innerHeight - 50,
    );

    setStyle({
      left: `${newLeft}px`,
      top: `${newTop}px`,
      right: 'unset',
      bottom: 'unset',
    });

    const mainElement = modalMainElement;
    const headerElement = mainElement?.querySelector<HTMLElement>(
      '.window__modal .modal__header',
    );
    const modalContent = mainElement?.querySelector<HTMLElement>(
      '.window__modal .modal__content',
    );

    if (modalContent && mainElement) {
      const headerBounding = headerElement?.getBoundingClientRect();
      const contentBounding = mainElement.getBoundingClientRect();

      applyStylesToElement(modalContent, {
        maxHeight: `${window.innerHeight - newTop - (headerBounding?.height ?? 0)}px`,
      });

      mainElement.dataset.originalWidth =
        mainElement.dataset.originalWidth || String(contentBounding!.width);
      applyStylesToElement(mainElement, {
        maxWidth: `${Math.min(Number.parseInt(mainElement.dataset.originalWidth, 10), window.innerWidth - newLeft)}px`,
      });
    }
  }
}
